import { create } from 'zustand';
import { CuttingSize } from '@/types/cutting';

interface CuttingSizeStore {
  selectedCuttingSize: CuttingSize | null;
  setSelectedCuttingSize: (cuttingSize: CuttingSize | null) => void;
}

export const useCuttingSizeStore = create<CuttingSizeStore>((set) => ({
  selectedCuttingSize: null,
  setSelectedCuttingSize: (cuttingSize) => set({ selectedCuttingSize: cuttingSize }),
}));
